const DAY_START_HOUR = 6;
const NIGHT_START_HOUR = 20;
const IMAGE_LOADED_CLASS = "section-hero__image--loaded";

const getSeasonByMonth = (month) => {
  if (month === 11 || month === 0 || month === 1) {
    return "winter";
  }

  if (month >= 2 && month <= 4) {
    return "spring";
  }

  if (month >= 5 && month <= 7) {
    return "summer";
  }

  return "autumn";
};

const getPeriodByHour = (hour) => {
  return hour >= DAY_START_HOUR && hour < NIGHT_START_HOUR ? "day" : "night";
};

const getDatasetKey = (season, period) => {
  return `image${season[0].toUpperCase()}${season.slice(1)}${period[0].toUpperCase()}${period.slice(1)}`;
};

const preloadImage = (source) => {
  return new Promise((resolve, reject) => {
    const preload = new Image();
    preload.onload = () => resolve(source);
    preload.onerror = reject;
    preload.src = source;
  });
};

const updateHeroImage = async (element) => {
  const now = new Date();
  const season = getSeasonByMonth(now.getMonth());
  const period = getPeriodByHour(now.getHours());

  const exactKey = getDatasetKey(season, period);
  const winterFallbackKey = getDatasetKey("winter", period);
  const defaultFallbackKey = getDatasetKey("winter", "day");
  const nextSource =
    element.dataset[exactKey] ||
    element.dataset[winterFallbackKey] ||
    element.dataset[defaultFallbackKey];

  if (!nextSource) {
    element.classList.add(IMAGE_LOADED_CLASS);
    return;
  }

  if (
    element.dataset.currentSource === nextSource ||
    element.dataset.pendingSource === nextSource
  ) {
    if (!element.classList.contains(IMAGE_LOADED_CLASS)) {
      element.classList.add(IMAGE_LOADED_CLASS);
    }
    return;
  }

  element.dataset.pendingSource = nextSource;

  try {
    await preloadImage(nextSource);
  } catch {
    delete element.dataset.pendingSource;
    element.classList.add(IMAGE_LOADED_CLASS);
    return;
  }

  if (element.dataset.pendingSource !== nextSource) {
    return;
  }

  const isInitialRender = !element.dataset.currentSource;

  if (element.getAttribute("src") !== nextSource) {
    element.setAttribute("src", nextSource);
  }

  if (isInitialRender) {
    element.classList.add(IMAGE_LOADED_CLASS);
  }

  element.dataset.currentSource = nextSource;
  element.dataset.currentSeason = season;
  element.dataset.currentPeriod = period;
  delete element.dataset.pendingSource;
};

export const initHeroImageBySeason = (root = document) => {
  const heroImages = root.querySelectorAll("[data-hero-image]");

  if (heroImages.length === 0) {
    return;
  }

  heroImages.forEach((element) => {
    updateHeroImage(element);
  });
};
